<template>

    <div :class=" navbarClasses " v-if=" !isShowTopNav() ">

        <TopHeader></TopHeader>
        <ToolBar></ToolBar>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    import NavIcon from './NavIcon';
    import ToolBar from './ToolBar';
    import TopHeader from './TopHeader';

    export default {

        name: 'top-nav',
        components: {

            NavIcon,
            ToolBar,
            TopHeader
        },
        computed: {

            ...mapGetters({

                isAuth            : 'auth/isAuth',
                topHeaderOpen     : 'nav/topHeaderOpen',
                currentRoute      : 'currentRoute',
                currentMerchant   : 'merchant/currentMerchant',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            navbarClasses: function (){

                const base = [ 'top-navbar' ];
                base.push( ( this.currentMerchant.merchantId == this.merchantIdCrocante ) ? 'solid-crocante' :  'solid');
                base.push( ( this.topHeaderOpen ) ? 'header-open' : 'header-close' );
                return base.join( ' ' );
            }
        },
        methods: {

            isShowTopNav(){
                return this.currentRoute.name == 'not-found' || this.currentRoute.name == 'signin';
            }
        }

    }
</script>

<style scoped>

    .top-navbar {

        display: flex;
        flex-direction: column;
        align-items: center;

        position: fixed;
        width: 100%;
        top: 0; left: 0; right: 0;

        background-color: rgba(32, 27, 27, 1);
        margin: 0;
        z-index: 250;
        transition: top 0.4s ease-in;
    }

    .solid {

        background-color: #e10b00;
        border-bottom: 1px solid #e10b00;
    }

    .solid-crocante {

        background-color: #DFEC72;
        border-bottom: 1px solid #DFEC72;
    }
    .transparent {

        background-color: transparent;
    }

    .header-open {

        top: 0;
    }
    .header-close {

        top: -125px;
    }

    @media screen and ( max-width: 420px ){

        .transparent {

            box-shadow: 0px 2px 10px 2px rgba( 50, 50, 50, 0.5 );
            background-color: rgba(32, 27, 27, 1);
        }
    }

</style>
